import React from 'react';
import s from './CandidateInfoDataTable.scss';

export const candidatePersonalTableMapping = {
  occupation: 'Occupation',
  name: 'Full Name',
  birthDate: 'Date of Birth',
  birthPlace: 'Place of Birth',
  fatherName: "Father's Name",
  motherName: "Mother's Name",
  spouse: "Spouse's Name",
  age: 'Age',
  category: 'Category',
  gender: 'Gender',
  vote: 'Vote',
  vote_Percent: 'Vote Percentage',
  education: 'Education',
  criminalCases: 'Criminal Cases',
  immovable: 'Immovable Property',
  assets: 'Total Assets',
  serious_ipc_counts: 'Serious IPC Counts',
  movable: 'Movable Property',
  liabilities: 'Liabilities',
  pan: 'PAN (Yes/No)',
  self: 'Self Income',
  total: 'Total Income',
};

export const candidatePoliticalMapping = {
  cn: 'Name',
  pn: 'Party Name',
  sn: 'State',
  cns_name: 'Constituency Name',
  constiteuncyType: 'Seat Type',
  ey: 'Year',
};

const CandidateInfoDataTable = ({ tableMapping, data, title }) => (
  <div className={`${s.candidateInfo}`}>
    <div className={s.topInfo}>{title}</div>
    {Object.entries(tableMapping).map(
      ([key, value]) =>
        data[key] && (
          <div className={s.infoRow} key={key}>
            <div className={s.infoCol}>{value}</div>
            <div className={s.infoCol}>{data[key]}</div>
          </div>
        ),
    )}
  </div>
);

export default CandidateInfoDataTable;
